














































































































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import moment from 'moment';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'items',
    ]),
    ...mapGetters(STORE_KEY, [
      'total'
    ])
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions', 'exportDataAsXLSX', 'exportDataAsPDF'
    ])
  },
  components: {
    TitleBar
  }
})
export default class MarginalityReport extends Vue {

  get titleStack () {
    return [
      'Отчеты',
      'По заявкам c чизкейками'
    ]
  }

  localFilter = {
    dManagers: null,
    dZoneGroups: null,
    warehouses: null,
    targetDates: [new Date(), new Date()],
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'expected_delivery_date', this.$route.query.sortDirection || 'asc']
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.dZoneGroups = (this.$route.query && this.$route.query.dZoneGroups)? this.$route.query.dZoneGroups : null;
    // @ts-ignore
    this.localFilter.dManagers = (this.$route.query && this.$route.query.dManagers)? this.$route.query.dManagers : null;
    // @ts-ignore
    this.localFilter.warehouses = (this.$route.query && this.$route.query.warehouses)? this.$route.query.warehouses : null;
    // @ts-ignore
    this.localFilter.targetDates = (this.$route.query && this.$route.query.targetDates) ? [moment(this.$route.query.targetDates[0]).toDate(), moment(this.$route.query.targetDates[1]).toDate()] : [new Date(), new Date()];
    // @ts-ignore
    this.localFilter.deliveryZone = (this.$route.query && this.$route.query.deliveryZone)? this.$route.query.deliveryZone : null;
    // @ts-ignore
    this.localFilter.clients = (this.$route.query && this.$route.query.clients)? this.$route.query.clients : null;

    this.handleParamsChange();
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] = (key == 'targetDates') ? [moment(this.localFilter[key][0]).format('YYYY-MM-DD'), moment(this.localFilter[key][1]).format('YYYY-MM-DD')] : this.localFilter[key]
      return ac;
    }, {});

    this.$router.replace({
      query
    })
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
